import type { IBaseAction } from '@models/actions/IBaseAction';
import type { IActionExecutor } from './IActionExecutor';

/**
 * Реестр фабрик исполнителей действий. Сервисы действий и UI достают исполнителя
 * через него, а не импортируют фабрики: фабрика тянет все исполнители с их модалками
 * и формами, а те — обратно сервисы и контролы форм. Фабрики регистрирует
 * `registerActionExecutors` при старте приложения.
 */
export type ActionExecutorFamily = 'doc' | 'linkedDoc' | 'activity' | 'process' | 'attach' | 'routeMap';

export type ActionExecutorFactory = (act: IBaseAction, throwError?: boolean) => IActionExecutor | undefined;

const factories = new Map<ActionExecutorFamily, ActionExecutorFactory>();

export function registerActionExecutorFactory(family: ActionExecutorFamily, factory: ActionExecutorFactory) {
    factories.set(family, factory);
}

export function getActionExecutor(
    family: ActionExecutorFamily,
    act: IBaseAction,
    throwError: boolean = true,
): IActionExecutor | undefined {
    const factory = factories.get(family);
    if (!factory) {
        throw new Error(`Фабрика исполнителей действий «${family}» не зарегистрирована`);
    }

    return factory(act, throwError);
}
